import { Row, Col, Button} from 'antd';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import LayoutPage from '../../layouts/Main'; // Si aún necesitas el Layout
import ProductList from './global_components/ProductsList';
import { ProductsData } from '../../data/product/productsData';

export default function Categories({node}) {
  let history = useNavigate();
  let token = localStorage.getItem('token');
  let role = localStorage.getItem('role');

  const handleClick = (sub) => {
    history(sub.link);
  };  

  const productsData = ProductsData;

  return (
    <LayoutPage>
      <Row gutter={[16, 16]}>
        {node.subCategories?.map((category, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={6}
            className="category-col"
            onClick={() => {
              handleClick(category);
            }}
          >
            <div className="gallery-card" style={{ backgroundImage: `url(${category.img})` }}>
              <div className="gallery-overlay">
                <div className="gallery-button">
                  <Button shape="circle" icon=">" />
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <ProductList products={productsData} catalog={node.name} category={""}/>
    </LayoutPage>
  );
}